import dayjs from "dayjs";

export const formattedDate = (date, includeTime = false) => {
  const format = includeTime ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY";
  return dayjs(date).format(format);
};
